export default "__VITE_ASSET__Bg7doI8R__"